class QuestionType {
  constructor({ id, name, formBuilderIndex, subtypes, options, label }) {
    this.id = id
    this.name = name
    this.subtypes = subtypes ?? []
    this.formBuilderIndex = formBuilderIndex ?? -1
    this.idForBuilder = options?.idForBuilder ?? id
    this.label = label
  }
}

export default QuestionType
